import styled from 'styled-components'
import { pxToRem } from '../../utils'

const WrapperLoader = styled.div`
  height: ${pxToRem(400)};
  position: relative;
  width: 100%;
`

export default WrapperLoader



// WEBPACK FOOTER //
// ./src/components/loaders/WrapperLoader.js